import axios from 'axios';
import dayjs from '@/helpers/dayjstz';
import cloneDeep from 'lodash/cloneDeep';

export const state = () => ({
    selected: null,
    items: [],
    areItemsFetched: false
});

export const getters = {
    selected: state => state.selected,
    items: state => state.items,
    areItemsFetched: state => state.areItemsFetched
};

export const mutations = {
    SET_ITEMS(state, items) {
        state.items = cloneDeep(items);
    },

    UPDATE_ITEM(state, item) {
        const index = state.items.findIndex(i => i.id === item.id);

        state.items.splice(index, 1, cloneDeep(item));
    },

    DELETE_ITEM(state, id) {
        const index = state.items.findIndex(item => item.id === id);

        state.items.splice(index, 1);
    },

    SET_ARE_ITEMS_FETCHED(state, areItemsFetched) {
        state.areItemsFetched = areItemsFetched;
    },

    SET_SELECTED(state, item) {
        state.selected = item;
    }
};

export const actions = {
    async index({ commit, getters: { items, areItemsFetched } }, { forced = false, businessProfileId } = {}) {
        if (businessProfileId) {
            const params = {
                business_profile_id: businessProfileId
            };

            return axios.$get('/v1/accounts', { params });
        }

        if (!forced && areItemsFetched) {
            return items;
        }

        const users = await axios.$get('/v1/accounts');

        commit('SET_ITEMS', users);
        commit('SET_ARE_ITEMS_FETCHED', true);

        return users;
    },

    store(vuexContext, { email, role, teamIds }) {
        return axios.$post('/v1/team_member_invites', {
            email,
            role,
            team_ids: teamIds
        });
    },

    async update({ commit }, { role, id, teamIds }) {
        const user = await axios.$patch(`/v1/accounts/${id}`, {
            role,
            team_ids: teamIds
        });

        commit('UPDATE_ITEM', user);

        return user;
    },

    async destroy({ commit }, id) {
        await axios.$delete(`/v1/accounts/${id}`);

        commit('DELETE_ITEM', id);
    },

    getStats(vuexContext, { userId, contextId, contextType, time: [from, to] }) {
        const params = {
            account_ids: userId,
            'range[from]': dayjs.unix(from).toISOString(),
            'range[to]': dayjs.unix(to).toISOString()
        };

        if (contextId) {
            params.context_id = contextId;
        }

        if (contextType) {
            params.context_type = contextType;
        }

        return axios.$get('/v1/account_events', {
            params
        });
    },

    getLabelsStats(vuexContext, { userId, contextId, contextType, time: [from, to] }) {
        const params = {
            account_ids: userId,
            'range[from]': dayjs.unix(from).toISOString(),
            'range[to]': dayjs.unix(to).toISOString()
        };

        if (contextId) {
            params.context_id = contextId;
        }

        if (contextType) {
            params.context_type = contextType;
        }

        return axios.$get('/v1/account_events/labels', {
            params
        });
    },

    downloadCSV() {
        return axios.$get('/example-csv');
    },

    setSelected({ commit }, user) {
        commit('SET_SELECTED', user);
    }
};
